import HttpClient from "./index"
import ApiRoutes, { baseUrl } from "../config/endpoints"

export default class ProntoAiAPI extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  getProntoAiTable = ApiRoutes.ProntoAi.GetProntoAiTable
  getProntoAi = ApiRoutes.ProntoAi.GetProntoAi

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  getProntoAiTableData = (
    token: string,
    group_sk: string,
    region: string,
    practice_sk: any,
  ) => {
    return this.instance({
      method: this.getProntoAiTable.Method,
      url: this.getProntoAiTable.EndPoint(group_sk, region, practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getProntoAiData = (
    token: string,
    group_sk: string,
    region: string,
    practice_sk: any,
    metric_id: any,
  ) => {
    return this.instance({
      method: this.getProntoAi.Method,
      url: this.getProntoAi.EndPoint(group_sk, region, practice_sk, metric_id),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
}
